import React, { useEffect } from "react";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";
import { Howl } from "howler";

const TradingAnalysis = () => {
  useEffect(() => {
    const sound = new Howl({ src: ["assets/sounds/open.wav"], volume: 0.6 });
    sound.play();
  }, []);
  return (
    <>
      <Header2 />
      <main className="main">
        <div className="analysis">
          <div className="wrapper">
            <a className="analysis-back gem-link" href="/dashboard">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                role="img"
                className="iconify iconify--material-symbols"
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="m7.825 13l5.6 5.6L12 20l-8-8l8-8l1.425 1.4l-5.6 5.6H20v2z"
                ></path>
              </svg>
              Back to Home
            </a>
            <div className="gem-section">
              <div className="AiAnalysis-heading">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  role="img"
                  className="AiAnalysis-icon iconify iconify--tabler"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2-2a2 2 0 0 1-2-2a2 2 0 0 1-2 2m0-12a2 2 0 0 1 2 2a2 2 0 0 1 2-2a2 2 0 0 1-2-2a2 2 0 0 1-2 2M9 18a6 6 0 0 1 6-6a6 6 0 0 1-6-6a6 6 0 0 1-6 6a6 6 0 0 1 6 6"
                  ></path>
                </svg>{" "}
                Analyze a new trade
              </div>
              <div className="gem-section-light"></div>
            </div>
            <div className="AiAnalysis-main">
              <div className="AiAnalysis-main-inner">
                <div className="AiAnalysis-main-headings">
                  Get detailed AI analysis on most markets
                </div>
                <div className="input" data-colors="tertiary">
                  <div className="input-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      aria-hidden="true"
                      role="img"
                      className="iconify iconify--carbon"
                      width="1em"
                      height="1em"
                      viewBox="0 0 32 32"
                    >
                      <path
                        fill="currentColor"
                        d="M29.25 6.76a6 6 0 0 0-8.5 0l1.42 1.42a4 4 0 1 1 5.67 5.67l-8 8a4 4 0 1 1-5.67-5.66l1.41-1.42l-1.41-1.42l-1.42 1.42a6 6 0 0 0 0 8.5A6 6 0 0 0 17 25a6 6 0 0 0 4.27-1.76l8-8a6 6 0 0 0-.02-8.48"
                      ></path>
                      <path
                        fill="currentColor"
                        d="M4.19 24.82a4 4 0 0 1 0-5.67l8-8a4 4 0 0 1 5.67 0A3.94 3.94 0 0 1 19 14a4 4 0 0 1-1.17 2.85L15.71 19l1.42 1.42l2.12-2.12a6 6 0 0 0-8.51-8.51l-8 8a6 6 0 0 0 0 8.51A6 6 0 0 0 7 28a6.07 6.07 0 0 0 4.28-1.76l-1.42-1.42a4 4 0 0 1-5.67 0"
                      ></path>
                    </svg>
                  </div>
                  <input
                    autocomplete="off"
                    id=":r2:"
                    type="text"
                    placeholder="Currency Pair, Stock Symbol or Tradingview link"
                    spellcheck="false"
                    value=""
                  />
                  <div className="corner" data-colors="tertiary">
                    <span className="corner-left"></span>
                    <span className="corner-right"></span>
                    <span className="corner-top-bottom"></span>
                  </div>
                </div>
                <button className="btn" data-colors="tertiary">
                  <span className="btn-txt">Analyze</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    aria-hidden="true"
                    role="img"
                    className="iconify iconify--tabler"
                    width="1em"
                    height="1em"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2-2a2 2 0 0 1-2-2a2 2 0 0 1-2 2m0-12a2 2 0 0 1 2 2a2 2 0 0 1 2-2a2 2 0 0 1-2-2a2 2 0 0 1-2 2M9 18a6 6 0 0 1 6-6a6 6 0 0 1-6-6a6 6 0 0 1-6 6a6 6 0 0 1 6 6"
                    ></path>
                  </svg>
                  <div className="corner" data-colors="tertiary">
                    <span className="corner-left"></span>
                    <span className="corner-right"></span>
                    <span className="corner-top-bottom"></span>
                  </div>
                </button>
                <div className="AiAnalysis-sub-headings">
                  DISCLAIMER:
                  <br />
                  The AIFlow Analysis Engine is still in development. If you have
                  a suggestion or input for this product, please contact our
                  development team. Thanks.
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default TradingAnalysis;
